const restaurant = {
  restaurant: "Nhà hàng", // translated 
  restaurants: "Nhà hàng", // translated 
  category: "Loại", // translated 
  score: "Điểm", // translated 
  priceQuartile: "Tứ phân vị giá", // translated 
  scoreLowestFirst: "Điểm số (từ thấp nhất lên trước)", // translated 
  scoreHighestFirst: "Điểm số (cao nhất trước)", // translated 
  priceLowestFirst: "Giá (từ thấp nhất đến cao nhất)", // translated 
  priceHighestFirst: "Giá (cao nhất trước)", // translated 
  allPrices: "Tất cả giá cả", // translated 
  reserve: "Dự trữ", // translated 
  dining: "Ăn uống", // translated 
};


export default restaurant;
